// extracted by mini-css-extract-plugin
export var dark = "ctaLegalLanguages-module--dark--2f29e";
export var legalLanguage = "ctaLegalLanguages-module--legalLanguage--ad336";
export var light = "ctaLegalLanguages-module--light--f4212";
export var termsSection = "ctaLegalLanguages-module--termsSection--c5c48";